<!--If component data exists-->
@if (downloadsComponentData$ | async; as data) {
  <div class="container-fluid">
    <!--if download item exists-->
    @if (downloadItems) {
      <div class="downloads-container {{ data.styleClasses ? data.styleClasses : ''}}" #tilesContainer>
        <!--Downloads title-->
        @if (data.config?.name) {
          <div class="col-xs-12">
            <h3 class="downloads-title">
              <span>{{ data.config.name }}</span>
            </h3>
          </div>
        }
        <div class="row">
          <!--show all the download items-->
          @if (
            downloadItems.length <= data.numberPerRow) {
            <!--download items loop-->
            @for (item of downloadItems; track item) {
              <div
                class="d-flex col-xs-6 col-sm-6 col-md-{{ columnsPerRow }} col-lg-{{ columnsPerRow }}">
                <!--download item-->
                <app-download-item [downloadItem]="item"
                [defaultThumbnail]="data.config?.defaultThumbnail"></app-download-item>
              </div>
            }
          } @else {
            <!--download items loop-->
            @for (item of downloadItems; track item; let i = $index) {
              <div
                class="col-xs-6 col-sm-6 col-md-{{ columnsPerRow }} col-lg-{{ columnsPerRow }}"
                >
                <!--download item-->
                <app-download-item [downloadItem]="item"
                  [defaultThumbnail]="data.config?.defaultThumbnail"
                [styleClasses]="data.styleClasses"></app-download-item>
              </div>
            }
          }
          <!--show less download items-->
        </div>
      </div>
    }
    @if (data.displayBottomLine === 'true') {
      <hr>
      }
    </div>
  }
